import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import { useApi, useAuth } from '../../hooks';
import { Meeting, MeetingFilter, PmStatus } from '../../models/meeting';

type Props = {
  filter?: MeetingFilter;
  is_active?: boolean;
  order_by?: 'asc' | 'desc';
  pm_status?: PmStatus;
};

export const useUserMeetings = ({
  filter,
  is_active,
  order_by,
  pm_status,
}: Props = {}) => {
  const { api } = useApi();
  const { userToken } = useAuth();

  const queryStr = qs.stringify({
    filter,
    is_active,
    order_by,
    pm_status,
  });

  const getUserMeetings = async (): Promise<Meeting[]> => {
    return await api({
      route: `/private/user/meeting/${queryStr ? `?${queryStr}` : ''}`,
      method: 'GET',
      token: userToken,
    });
  };

  const { data, isLoading, isError, refetch } = useQuery<Meeting[], Error>({
    queryKey: ['user-meetings', queryStr, userToken],
    queryFn: getUserMeetings,
    enabled: !!userToken,
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};

export default useUserMeetings;
